import { refreshCartFragments } from "../../utils/cart-fragments";

export default function initCartCoupon() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    // #coupon-message est à l'intérieur de .widget_shopping_cart_content,
    // donc remplacé par le fragment refresh : on affiche le message APRÈS
    // le refresh pour qu'il ne soit pas effacé immédiatement, puis on
    // l'efface nous-mêmes après quelques secondes.
    // On n'affiche que les erreurs : le succès est déjà matérialisé par la
    // ligne du coupon appliqué (et le masquage du formulaire).
    function showMessage(html) {
        if (html.indexOf('woocommerce-error') === -1) {
            $('#coupon-message').html('');
            return;
        }
        $('#coupon-message').html(html);
        setTimeout(function () {
            $('#coupon-message').html('');
        }, 4000);
    }

    // Appliquer un coupon
    $(document).on('click', '.js-apply-coupon', function () {
        var code = $('#mini_cart_coupon_code').val().trim();
        if (!code) return;

        var nonceApply = $(this).closest('.mini-cart-coupon').data('nonce-apply');
        var $btn = $(this).prop('disabled', true).addClass('loading');

        $.post('/?wc-ajax=apply_coupon', {
            coupon_code: code,
            security: nonceApply
        })
            .done(function (response) {
                refreshCartFragments().then(function () {
                    showMessage(response); // WC retourne le HTML de la notice
                });
            })
            .always(function () {
                $btn.prop('disabled', false).removeClass('loading');
            });
    });

    // Supprimer un coupon
    $(document).on('click', '.js-remove-coupon', function () {
        var coupon = $(this).data('coupon');
        var nonceRemove = $(this).closest('.mini-cart-coupon').data('nonce-remove');

        $.post('/?wc-ajax=remove_coupon', {
            coupon: coupon,
            security: nonceRemove
        })
            .done(function () {
                refreshCartFragments();
            });
    });

    // Soumettre avec Entrée
    $(document).on('keydown', '#mini_cart_coupon_code', function (e) {
        if (e.key === 'Enter') {
            $('.js-apply-coupon').trigger('click');
        }
    });
}
